import './Side.css';

// Vendors
import React from 'react';
import classnames from 'classnames';
import STATUS from '../Game/constants';
import {CSSTransition} from 'react-transition-group';

export default class Side extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      status: props.status
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return  nextProps.status === STATUS.GAME_START ||
            nextProps.status === STATUS.GAME_EXIT ||
            nextProps.status === STATUS.GAME_PLAY ||
            nextState.status !== this.state.status;
  }

  render() {
    const classes = classnames(
      'Side',
      this.props.behavior,
    )

    const enterClass = this.props.status === STATUS.GAME_PLAY ? (this.props.behavior === 'negative' ? 'enter-left' : 'enter-right') : '';
    const exitClass = this.props.status === STATUS.GAME_EXIT ? (this.props.behavior === 'negative' ? 'exit-left' : 'exit-right') : '';
    const colClasses = classnames(
      'Side-col',
      enterClass,
      exitClass,
    )

    // Determine when to render the component
    const showComponent = this.props.status === STATUS.GAME_START ||
                          this.props.status === STATUS.GAME_EXIT ||
                          this.props.status === STATUS.GAME_PLAY;

    return (
      <CSSTransition
        in={showComponent}
        timeout={350}
        classNames="fade"
        unmountOnExit
      >
        <div className={colClasses} data-behavior={this.props.behavior}>
          <div className={classes}>
            <div className="label-box">
              <div className="label">
                {this.props.behavior === 'positive' ? "Positive behaviour" : "Negative behaviour"}
              </div>
            </div>
          </div>
        </div>
      </CSSTransition>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/rlgl/Side/Side.js